<!-- Header -->
<div class="sub-header">
  <div class="container" style="height: 100%;">
    <div class="controls-panel">
      <input type="text" name="search" class="form-control" placeholder="Search by Name or Code"
        [(ngModel)]="ibisQueryParam.query" style="border-color:#CFD7E6;font-weight:200;"
        (ngModelChange)="filterList()">
      <button type="button" class="btn btn-bvq pull-right ml-2" (click)="openModal(template)">Upload</button>
      <button type="button" class="btn btn-bvq pull-right ml-2" (click)="createIBIS()">Create IBIS Report</button>
    </div>
  </div>
</div>

<!-- Loading bar -->
<app-loader [loading]="loading"></app-loader>

<!-- List of IBIS -->
<div class="container" [hidden]="loading">
  <!-- No ibis found message -->
  <div class="no-items" *ngIf="ibisList?.length == 0">
    No IBIS found
  </div>

  <!-- IBIS Header -->
  <div class="ibis-header" *ngIf="ibisList?.length > 0">
    <div class="item">
      <div class="row">
        <div class="col-md-1">
          <span (click)="sortIbis('CODE')">
            Code
            <i
              class="fa {{ibisQueryParam.field === 'CODE' ? ibisQueryParam.order === 'ASC' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc' : 'fa-sort'}}"></i>
          </span>
        </div>
        <div class="col-md-1">
          <span (click)="sortIbis('DATE')">
            Date
            <i
              class="fa {{ibisQueryParam.field === 'DATE' ? ibisQueryParam.order === 'ASC' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc' : 'fa-sort'}}"></i>
          </span>
        </div>
        <div class="col-md-1">
          <span (click)="sortIbis('VERSION')">
            Ver
            <i
              class="fa {{ibisQueryParam.field === 'VERSION' ? ibisQueryParam.order === 'ASC' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc' : 'fa-sort'}}"></i>
          </span>
        </div>
        <div class="col-md-8">
          <span (click)="sortIbis('NAME')">
            Name
            <i
              class="fa {{ibisQueryParam.field === 'NAME' ? ibisQueryParam.order === 'ASC' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc' : 'fa-sort'}}"></i>
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- IBIS List -->
  <div class="ibis-list" *ngIf="ibisList?.length > 0">
    <div class="ibis">
      <div *ngFor="let ibis of ibisList; let i = index;">
        <div class="item">
          <div class="row">

            <!-- Ibis Code -->
            <div class="column col-md-1" [ngClass]="{'pointer': ibis.VERSION === 0}" (click)="ibis.VERSION === 0 ? createIBISReport(ibis) : ''">
              <div>{{ibis.CODE}}</div>
            </div>

            <!-- Ibis Date -->
            <div class="column col-md-1" [ngClass]="{'pointer': ibis.VERSION === 0}" (click)="ibis.VERSION === 0 ? createIBISReport(ibis) : ''">
              <div>{{ibis.DATE}}</div>
            </div>

            <!-- Ibis Version -->
            <div class="column col-md-1" [ngClass]="{'pointer': ibis.VERSION === 0}" (click)="ibis.VERSION === 0 ? createIBISReport(ibis) : ''">
              <div>{{ibis.VERSION === 0 ? 'DB' :ibis.VERSION}}</div>
            </div>

            <!-- Ibis Name -->
            <div class="column col-md-8" [ngClass]="{'pointer': ibis.VERSION === 0}" (click)="ibis.VERSION === 0 ? createIBISReport(ibis) : ''">
              <div>
                <span class="draft" *ngIf="ibis.DRAFT">Draft</span>
                {{ibis.NAME}}
              </div>
            </div>

            <!-- Ibis options -->
            <div class="column end col-md-1 action">
              <div class="btn-group" dropdown>
                <button dropdownToggle type="button" class="btn btn-default btn-sm dropdown-toggle sub"
                  placement="bottom right">
                  <i class="fa fa-ellipsis-v"></i>
                </button>

                <div *dropdownMenu class="drop-menu">
                  <a class="drop-item" (click)="removeIbis(ibis)">
                    <div class="item" style="display: contents;">Delete</div>
                  </a>
                  <!--
                  <a class="drop-item" (click)="downloadPDF(ibis)">
                    <div class="item" style="display: contents;">Download</div>
                  </a>-->
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Ibis Pagination -->
  <div class="pagination-wrapper pagination-cls" [hidden]="loading || totalItems < 25">
    <pagination [boundaryLinks]="true" [totalItems]="totalItems" [itemsPerPage]="25" [maxSize]="5"
      (pageChanged)="pageChanged($event)" class="pagination-sm"></pagination>
  </div>
</div>

<!-- Modal to crete new ibis item -->
<ng-template #template id="CreateNewIBIS">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Upload IBIS Reports</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)"
      (onFileLeave)="fileLeave($event)" accept="application/pdf" multiple="true" dropZoneLabel="Drop and drop pdf file">
      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        <div class="d-block">
          <div class="text-center">Drag and drop pdf file</div>
          <div class="text-center m-t-10"><a class="pick-file" (click)="openFileSelector()">Or pick file by clicking Here</a></div>
        </div>
      </ng-template>
    </ngx-file-drop>
    <div *ngIf="showProgress" style="margin: 15px 0px;">
      <progressbar [max]="100" [value]="progress" type="success" [striped]="true" [animate]="true"><b>uploading
          {{progress}}%</b></progressbar>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="isAllFilesUploaded" class="btn btn-rbv" (click)="closeModal()" style="margin-right: 10px;">
      OK
    </button>
    <button class="btn btn-rbv" (click)="closeModal()">
      Cancel
    </button>
  </div>
</ng-template>
